import { tKey } from "@/core/i18n";
import { Database, Images, SlidersHorizontal, Sparkles } from "lucide-react";
import { Button } from "@/modules/shadcn/ui/button";
import { useTranslation } from "react-i18next";
import { StartupScreen, type StartupStep } from "../StartupScreen";

export interface SuggestionLoadingScreenProps {
  onSkip: () => void;
}

const STEPS: StartupStep[] = [
  {
    key: "analytics",
    label: tKey("model:suggestionLoading.steps.analytics"),
    icon: Database,
    estimatedMs: 5_000,
  },
  {
    key: "sampling",
    label: tKey("model:suggestionLoading.steps.sampling"),
    icon: Images,
    estimatedMs: 8_000,
  },
  {
    key: "analysis",
    label: tKey("model:suggestionLoading.steps.analysis"),
    icon: Sparkles,
    estimatedMs: 25_000,
  },
  {
    key: "config",
    label: tKey("model:suggestionLoading.steps.config"),
    icon: SlidersHorizontal,
    estimatedMs: 17_000,
  },
];

export const SuggestionLoadingScreen = ({ onSkip }: SuggestionLoadingScreenProps) => {
  const { t } = useTranslation(["model", "common"]);
  return (
    <StartupScreen
      icon={Sparkles}
      heading={t("suggestionLoading.heading")}
      subtitle={t("suggestionLoading.subtitle")}
      steps={STEPS}
      action={
        <Button variant="outline" onClick={onSkip}>
          {t("suggestionLoading.skip")}
        </Button>
      }
    />
  );
};
